import { useState, useEffect } from "react";
import { ViewerFileType } from "../../../FileViewer/services/fileViewerInterface";

const ZOOM_LEVELS = [50, 75, 90, 100, 110, 125, 150, 175, 200];

const DEFAULT_ZOOM = 100;

const ZOOMABLE_TYPES = new Set<ViewerFileType>([
  "email",
  "docx",
  "pptx",
  "onenote-page",
  "evestment-note",
  "teams-post",
  "altvia_interaction",
  "altvia_interaction_note",
  "finpilot-interaction",
]);

const useDocumentZoom = ({
  fileId,
  fileType,
}: {
  fileId: string;
  fileType: ViewerFileType | null | undefined;
}) => {
  const [zoomLevel, setZoomLevel] = useState(DEFAULT_ZOOM);

  useEffect(() => {
    setZoomLevel(DEFAULT_ZOOM);
  }, [fileId]);

  const isZoomable = fileType ? ZOOMABLE_TYPES.has(fileType) : false;

  const zoomIn = () => {
    setZoomLevel((prev) => {
      const idx = ZOOM_LEVELS.findIndex((l) => l >= prev);
      return idx < ZOOM_LEVELS.length - 1 ? ZOOM_LEVELS[idx + 1] : prev;
    });
  };

  const zoomOut = () => {
    setZoomLevel((prev) => {
      const idx = ZOOM_LEVELS.findIndex((l) => l >= prev);
      return idx > 0 ? ZOOM_LEVELS[idx - 1] : prev;
    });
  };

  const resetZoom = () => setZoomLevel(DEFAULT_ZOOM);

  return { zoomLevel, isZoomable, zoomIn, zoomOut, resetZoom };
};

export default useDocumentZoom;
